<template>
  <div id="modals-container">
    <app-modal v-for="modal in modals" :key="modal.id" v-bind:id="modal.id" @remove="remove">
      <component :is="modal.component" @close="close(modal.id)" v-bind="modal.props" v-on="modal.events"></component>
    </app-modal>
  </div>
</template>

<script>
import AppModalPlugin from './AppModalPlugin.js';

export default {

  data() {
    return {
      uid: 0,
      modals: []
    };
  },

  created() {
    this.$modal.setContainer(this);
  },

  methods: {
    add(modal, props, events) {
      const id = this.uid++
      this.modals.push({
        id: id,
        component: modal,
        props: props,
        events: events
      });
      document.body.style.overflowY = 'hidden';
    },

    remove(id) {
      for (let i in this.modals) {
        if (this.modals[i].id === id) {
          this.modals.splice(i, 1);
          if (!this.modals.length) {
            document.body.style.overflowY = 'auto';
          }
          return;
        }
      }
    },

    close(id) {
      AppModalPlugin.event.$emit('close', id);
    }
  }
};
</script>